import { Tool } from '../../data/tools';

export const metadata: Tool = {
  id: 'nasa-apod',
  name: 'NASA Astronomy Picture of the Day',
  description: 'Explore the universe through NASA\'s daily astronomical images, videos, and descriptions.',
  category: 'Science',
  icon: 'Sparkles',
  route: '/tools/nasa-apod',
  metaTitle: 'NASA Astronomy Picture of the Day — Daily Space Photo Explorer',
  metaDescription: 'Browse NASA APOD photos and videos instantly. Search by date to discover daily universe snaps, planet views, and cosmic events with official NASA descriptions.',
  keywords: [
    'nasa apod online',
    'astronomy picture of the day',
    'daily space photo',
    'nasa image finder',
    'hubble space photos',
    'cosmic picture explorer',
    'nasa daily image'
  ],
  longDescription: 'The NASA Astronomy Picture of the Day (APOD) tool allows users to view the current daily space image, video, and comprehensive description provided directly by NASA astronomers. Users can also select any date back to June 1995 to discover historical images of nebulas, stars, galaxies, and planetary missions.',
  howToUse: [
    'View the current day\'s astronomy picture or video automatically.',
    'Use the date picker input to select any historical date from June 1995 onwards.',
    'Click the "Download HD" button to save high-resolution pictures to your device.',
    'Read the detailed explanation written by professional NASA astrophysicists.'
  ],
  benefits: [
    'Fetches live, authentic astronomical content directly from NASA APIs.',
    'Fast, responsive image lazy-loading optimized for mobile and desktop screens.',
    'Interactive historical search enables classroom and educational research.'
  ],
  faq: [
    {
      question: 'What is NASA APOD?',
      answer: 'NASA\'s Astronomy Picture of the Day (APOD) is a website provided by NASA and Michigan Technological University that features a different image or photograph of our universe each day, along with a brief explanation written by a professional astronomer.'
    },
    {
      question: 'How far back can I search for space photos?',
      answer: 'You can search for any date starting from June 16, 1995, which is when the official NASA APOD archive was first launched.'
    },
    {
      question: 'Why are some dates displaying videos instead of images?',
      answer: 'NASA occasionally features interactive media, rocket launch videos, or 3D animations instead of static photos to represent the astronomy topic of the day.'
    }
  ]
};
